export const AUTOPILOT_BASE_PATH = '/autopilot';

/** Canonical path for both blue and NewAIAvatarLayout themes. */
export const BLUE_LAYOUT_BASE_PATH = AUTOPILOT_BASE_PATH;
export const AI_AVATAR_BASE_PATH = AUTOPILOT_BASE_PATH;

/** Legacy paths kept only for redirects / resource_mappings compat. */
export const LEGACY_AI_AVATAR_AUTOPILOT_PATH = '/ai-avatar-layout/autopilot';
export const LEGACY_AI_AVATAR_MEASURE_PATH = '/ai-avatar-layout/measure';

export const resolveAutopilotBasePath = (_pathname?: string): string =>
  AUTOPILOT_BASE_PATH;

export const buildAutopilotAskMiaPath = (
  basePath: string = AUTOPILOT_BASE_PATH,
): string => `${basePath}/ask-mia`;

export const isAutopilotPath = (pathname?: string): boolean => {
  if (!pathname) return false;
  const path = pathname.split('?')[0].split('#')[0];
  return path === AUTOPILOT_BASE_PATH || path.startsWith(`${AUTOPILOT_BASE_PATH}/`);
};
